const letter = (i) => String.fromCharCode(65 + i);

function filled(part, q, value) {
  if (value === undefined || value === "") return null;
  if (part.type === "cloze") return q.options[value];
  if (part.type === "gapped") return letter(value);
  return value;
}

export const GappedPassage = ({ part, currentNumber, answers }) => {
  const byNumber = Object.fromEntries(part.questions.map((q) => [String(q.number), q]));
  const blocks = part.passage.split(part.type === "notes" ? "\n" : "\n\n");
  return (
    <div className={part.type === "notes" ? "space-y-3" : "space-y-4"} data-testid="test-gapped-passage">
      {blocks.map((block, bi) => (
        <p key={bi} className={`text-[15px] leading-[1.9] text-foreground/85 ${part.type === "notes" && bi === 0 ? "font-bold text-foreground tracking-wide" : ""}`}>
          {block.split(/\{(\d+)\}/).map((chunk, ci) => {
            if (ci % 2 === 0) return <span key={ci}>{chunk}</span>;
            const q = byNumber[chunk];
            const val = filled(part, q, answers[q.id]);
            const active = String(currentNumber) === chunk;
            return (
              <span
                key={ci}
                data-testid={`test-gap-${chunk}`}
                className={`inline-flex items-center gap-1.5 mx-1 px-2 py-0.5 align-baseline text-sm border ${
                  active ? "bg-signal border-signal text-ink" : "border-foreground/40 bg-transparent"
                }`}
              >
                <span className="font-mono-fig text-[11px] opacity-80">{chunk}</span>
                <span className="font-medium">{val || "______"}</span>
              </span>
            );
          })}
        </p>
      ))}
    </div>
  );
};

export const NoticeCard = ({ q }) => (
  <div className="neu rounded-2xl p-6" data-testid="test-notice-card">
    <div className="overline">{q.kind}</div>
    <div className="mt-4 whitespace-pre-line text-lg leading-relaxed text-foreground font-medium">{q.text}</div>
  </div>
);

export const ChoiceDirectory = ({ choices }) => (
  <div className="space-y-3 max-h-[60vh] overflow-y-auto pr-1" data-testid="test-matching-choices">
    {choices.map((c, i) => (
      <div key={i} className="py-3 border-b border-foreground/20">
        <div className="font-bold text-foreground text-sm"><span className="font-mono-fig mr-3">{letter(i)}</span>{c.title}</div>
        <p className="mt-1 text-sm text-foreground/80 leading-relaxed">{c.text}</p>
      </div>
    ))}
  </div>
);

export const Passage = ({ part }) => (
  <div className="space-y-4">
    {part.passage.split("\n\n").map((p, i) => (
      <p key={i} className="text-[15px] leading-[1.8] text-foreground/85">{p}</p>
    ))}
  </div>
);
